module.exports = __webpack_public_path__ + "img/9788962807707.4f3fb607.jpg";